<template>

  <div>
    <h1 class="display-2 text-center my-3 mt-6">All Users</h1>
  <!-- old stuff -->
      <v-layout>
        <v-flex xs12 sm10 md8 offset-sm1 offset-md2>
          <v-card
            class="mx-auto"
            max-width="400"
            v-for="social in allUsers" :key="social.id"
            >
                <v-img
                class="white--text align-end"
                height="200px"
                :src="social.profilePic"
                v-if="social.profilePic !== ''"
                >
                <v-card-title>{{social.name}}</v-card-title>
                </v-img>

                <v-img
                class="white--text align-end"
                height="200px"
                src="https://wallpapercave.com/wp/IooPgL8.jpg"
                v-else
                >
                <v-card-title>{{social.name}}</v-card-title>
                </v-img>

                <v-card-text class="text--primary">
                <div>{{social.online === true ? 'Online' : 'Offline'}}</div>

                <div>{{social.bio}}</div>
                </v-card-text>

                <v-card-actions>
                <v-btn
                  text
                  color="deep-purple accent-4"
                  :to="'/messages/' + social.id"
                >
                  Message
                </v-btn>
                <v-btn
                  text
                  color="deep-purple accent-4"
                  :to="'/profile/' + social.id"
                >
                  Read Profile
                          </v-btn>
                <v-spacer></v-spacer>
                <v-btn v-if="!friends(social.id)" @click="sendRequest(social.id)">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-flex>
      </v-layout>
      <Usercard></Usercard>
    </div>
</template>

<script>
import Usercard from '@/components/Frontend/UserCard.vue'
import {mapGetters} from 'vuex'
export default {
  props: ['id'],
  computed: {
    ...mapGetters(['allUsers'])
  },
  methods: {
    onLoadFriend(friendid){
      this.$router.push('/profile/' + friendid)
    },
    newUser(social) {
        return this.$store.state.allUsers[social].name
    },
     newProfile(social) {
        return this.$store.state.allUsers[social].profilePic
    },
    sendRequest(social){
        let gr= this.$store.state.groupChat[this.id]
      this.$store.dispatch('firebaseUpdateChatMembers', {
          chatId: this.id,
          memberId: social,
          member: {
              member: true
          },
          group: {
              ...gr
          }
          
      })
    },
    friends(social){
      return this.$store.state.groupMembers[social]
    }
  },
  components: {
    Usercard,
  },
  mounted() {
    this.$store.dispatch('firebaseGetGroupMembers', this.id)
    this.$store.dispatch('firebaseGetDMs')
    this.$store.dispatch('firebaseGetFriends')
    this.$store.dispatch('fetchFeed')
    this.$store.dispatch('fetchPrivateFeed')
    this.$store.dispatch('firebaseGetPostInteraction')
    this.$store.dispatch('firebaseDeletePosts')
    this.$store.dispatch('firebaseGetGroupChat')
    this.$store.dispatch('firebaseGetNotifications')
  },
  destroyed(){
    this.$store.dispatch('firebaseStopGettingGroupMembers', this.id)
  }

}
</script>
